module.exports = __webpack_public_path__ + "static/media/Brightly_ios_3_preview.88ba5508.jpg";